//@flow
import {useSelector} from 'react-redux';

import {useActions} from '../../../utils/globalStore';
import {actions} from '../duck';

import type {BlogAuthor} from '../../../entities';
import type {RootState} from '../../';
import {useEffect} from 'react';
import {getAuthorListService} from '../promises/blog-author';

export function useBlogAuthorsActions() {
  const setAuthors = useActions(actions.setBlogAuthors);

  const setBlogAuthors = (authors: BlogAuthor[]) => {
    setAuthors(authors);
  };

  return {
    setBlogAuthors,
  };
}

export function useInitializeBlogAuthors() {
  const authors = useSelector(authorsSelector);

  const setBlogAuthors = useActions(actions.setBlogAuthors);
  useEffect(() => {
    const getAuthors = async () => {
      const authors = await getAuthorListService();
      setBlogAuthors(authors || []);
    };

    getAuthors().catch(() => {
      setBlogAuthors([]);
    });
  }, [setBlogAuthors]);

  return {
    authors,
  };
}

const authorsSelector = (state: RootState) => state.blog.authors;

export function useBlogAuthors() {
  const authors = useSelector(authorsSelector);

  return authors || [];
}
